import React from "react";

function LeaveChatIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
            >
                <circle
                    id="Oval-5"
                    cx="8"
                    cy="8"
                    r="10"
                    fill="currentColor"
                    opacity=".3"
                />
                <rect
                    x="2"
                    y="7"
                    width="12"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
                    x="2"
                    y="7"
                    width="12"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
}

export default LeaveChatIcon;
